//Import React
import React, { useContext, useEffect, useState } from "react";
import Select, { components } from "react-select";
import { useLocation } from "react-router-dom";
//Import Context
import { AppContext } from "../../../contexts/AppContext";
import { AuthContext } from "../../../contexts/AuthContext";
import staticData from '../../../contexts/staticData.json';
//Import Helpers
import { formatDisplayName } from "../../../shared/helpers";
//Import Components
import ViewPendingPaymentRequest from "../../viewPendingRequests/ViewPendingPaymentRequest";
//Import Icons
import arrow from '../../../assets/icons/arrowSide.svg';
import downArrow from '../../../assets/icons/downArrow.svg';
//Import CSS
import './paymentRequest.css';

function PaymentRequest() {
    const location = useLocation();
    const { userData } = useContext(AuthContext);
    const { usersList, dataProjects, requestsList, establishmentList, pmeList, viewPayment, setViewPayment, viewObservedPayment, setViewObservedPayment, viewRejectedPayment, setViewRejectedPayment, dataPaymentRequest, setDataPaymentRequest, selectedRequestPayment, setSelectedRequestPayment } = useContext(AppContext);
    const [pendingRequests, setPendingRequests] = useState([]);
    const [observedRequests, setObservedRequests] = useState([]);
    const [rejectedRequests, setRejectedRequests] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    
    useEffect(() => {
        if(location?.state){
            setViewPayment(location.state?.view || false);
            setViewObservedPayment(location.state?.viewObserved || false);
            setSelectedRequestPayment(location.state?.selectedRequest || null)
            setDataPaymentRequest(location.state?.data || {
                region: null,
                commune: null,
                holder: { value: null, id: null },
                establishment: { value: null, id: null }
            })
        };
    }, [location, setViewRejectedPayment, setViewObservedPayment, setSelectedRequestPayment, setDataPaymentRequest]);

    // useEffect(() => {
    //     if (userData?.dimension === 'Establecimiento' && establishmentList.length >0 && dataProjects.length > 0) {
    //         const getEstablishment = establishmentList.find(est => est.id === userData.establishmentId);
    //         const getProject = dataProjects.find(project => project.id === getEstablishment.projectId);
    //         setDataPaymentRequest(prevState => ({
    //             ...prevState,
    //             holder: {
    //                 value: getProject.nameProject,
    //                 id: getProject.id
    //             },
    //             establishment: {
    //                 value: getEstablishment.nameEstablishment,
    //                 id: getEstablishment.id
    //             }
    //         }))
    //     }
    // }, [userData?.dimension, userData?.establishmentId, setDataPaymentRequest, establishmentList, dataProjects]);

    useEffect(() => {
        if (userData?.dimension === 'Establecimiento' && establishmentList.length > 0 && dataProjects.length > 0) {
            const getEstablishment = establishmentList.find(est => est.id === userData.establishmentId);
            
            // Verificar que el establecimiento existe antes de continuar
            if (getEstablishment) {
                const getProject = dataProjects.find(project => project.id === getEstablishment.projectId);
                
                // Verificar que el proyecto existe antes de actualizar el estado
                if (getProject) {
                    // Comprobar si los valores son diferentes antes de actualizar
                    // para evitar actualizaciones innecesarias
                    setDataPaymentRequest(prevState => {
                        // Solo actualizar si los valores son diferentes
                        if (prevState.holder?.id !== getProject.id || 
                            prevState.establishment?.id !== getEstablishment.id) {
                            return {
                                ...prevState,
                                holder: {
                                    value: getProject.nameProject,
                                    id: getProject.id
                                },
                                establishment: {
                                    value: getEstablishment.nameEstablishment,
                                    id: getEstablishment.id
                                }
                            };
                        }
                        // Si los valores son iguales, devolver el estado anterior sin cambios
                        return prevState;
                    });
                }
            }
        }
    }, [userData?.dimension, userData?.establishmentId, establishmentList, dataProjects]);

    useEffect(() => {
        filterUsers();
        pendingRequestsSearch();
    }, [dataPaymentRequest, userData, usersList, requestsList]);

    const filterUsers = () => {
        let filtered = [];

        if ((userData?.permissions === 'admin' && dataPaymentRequest?.establishment) || userData?.dimension === 'Establecimiento') {
            filtered = usersList
                .filter((user) => user.tenantId === dataPaymentRequest.holder.id)
                .filter((user) => user.establishmentId === dataPaymentRequest.establishment?.id);
        }
        setFilteredUsers(filtered);
    };
    const pendingRequestsSearch = () => {
        let pending = [];
        let observed = [];
        let rejected = [];

        if ((userData?.permissions === 'admin' && dataPaymentRequest.establishment?.value) || (userData?.dimension === 'Establecimiento' && dataPaymentRequest.establishment?.value)) {
            requestsList.forEach((request) => {
                const lastHistoryItem = request?.history && request.history.length > 0
                    ? request.history[request.history.length - 1]
                    : null;
                const isCorrectProject = request?.idProject === dataPaymentRequest.holder?.id;
                const isCorrectEstablishment = request?.idEstablishment === dataPaymentRequest.establishment?.id;
                const isObserved = lastHistoryItem?.responseRequest === 'observed' && !lastHistoryItem?.response;
                if (isCorrectProject && isCorrectEstablishment) {
                    // Primero verificamos si es una solicitud de pago rechazada
                    if (request.typeOfRequest === 'payment' &&
                        request.state === 'rejected' &&
                        request.sentTo === 'Establecimiento') {
                        // Si es fullPayment o partialPayment rechazada, va a rejected
                        rejected.push(request);
                        return; // Continuamos con la siguiente iteración
                    }

                    const isValidState = request.typeOfRequest === 'payment'
                        ? request.state === 'pending'
                        : request.requestDetails.state === 'approved';

                    const isValidSentTo = request.typeOfRequest === 'payment'
                        ? request.sentTo === 'Establecimiento'
                        : request.requestDetails.sentTo === 'Establecimiento';

                    if (isValidSentTo && isValidState) {
                        if (isObserved) {
                            observed.push(request);
                        } else if (request.typeOfRequest === 'payment') {
                            pending.push(request);
                        } else {
                            const hasAssociatedPaymentRequest = requestsList.some(
                                paymentReq => paymentReq.originRequestId === request.id && paymentReq.typeOfRequest === 'payment'
                            );
                            if (!hasAssociatedPaymentRequest && lastHistoryItem?.responseRequest !== 'rejected') {
                                pending.push(request);
                            }
                        }
                    }
                }
            });

            setPendingRequests(pending);
            setObservedRequests(observed);
            setRejectedRequests(rejected);
        } else {
            setPendingRequests([]);
            setObservedRequests([]);
            setRejectedRequests([]);
        }
    };

    const handleSelect = (selectedOption, actionMeta) => {
        if (actionMeta.name === 'holder' || actionMeta.name === 'establishment') {
            setDataPaymentRequest(prevData => ({
                ...prevData,
                [actionMeta.name]: {
                    value: selectedOption.value,
                    id: selectedOption.id
                }
            }));
        } else {
            setDataPaymentRequest(prevData => ({ ...prevData, [actionMeta.name]: selectedOption.value }));
        }
    };

    const canViewPendingRequests = () => {
        return (
            ((userData?.permissions === 'admin' && dataPaymentRequest.holder.id) ||
                (userData?.dimension === 'Establecimiento'))
        );
    };

    const handleClick = (e) => {
        e.preventDefault();
        setViewPayment(true);
        setViewObservedPayment(false);
    };

    const handleClickObserved = (e) => {
        e.preventDefault();
        setViewObservedPayment(true);
        setViewPayment(false);
    };

    const handleClickRejected = (e) => {
        e.preventDefault();
        setViewPayment(false);
        setViewObservedPayment(false);
        setViewRejectedPayment(true);
    };

    return (
        <section className={`payment-request flex ${(viewPayment || viewObservedPayment || viewRejectedPayment) ? 'open-view-pending' : ''}`}>
            <header className='header-payment-request flex'>
                <h3>{dataPaymentRequest.holder.value && dataPaymentRequest.holder?.value}</h3>
                <img src={arrow} className='icon' alt='Icono de flecha' />
                <p>{dataPaymentRequest.establishment?.value}</p>
            </header>
            {userData?.permissions === 'admin' && (
                <article className='container-search box-input flex'>
                    <span className='input-select'>
                        <label htmlFor='region' className='hidden-label'>Región</label>
                        <Select
                            name='region'
                            id='region'
                            options={staticData.regiones.map((region) => ({
                                value: region.name,
                                label: region.name
                            }))
                                .sort((a, b) => a.label.localeCompare(b.label))}
                            placeholder='Selecciona Región'
                            className='custom-select'
                            classNamePrefix='custom-select'
                            components={{ DropdownIndicator }}
                            onChange={handleSelect}
                            value={dataPaymentRequest.region ? { value: dataPaymentRequest.region, label: dataPaymentRequest.region } : null}
                        />
                    </span>
                    <span className='input-select'>
                        <label htmlFor='commune' className='hidden-label'>Comuna</label>
                        <Select
                            name='commune'
                            id='commune'
                            options={dataPaymentRequest.region ? staticData.regiones.find(region => region.name === dataPaymentRequest.region)?.communes.map(commune => ({
                                value: commune.name,
                                label: commune.name
                            }))
                                .sort((a, b) => a.label.localeCompare(b.label)) : []}
                            placeholder='Selecciona Comuna'
                            className='custom-select'
                            classNamePrefix='custom-select'
                            components={{ DropdownIndicator }}
                            onChange={handleSelect}
                            value={dataPaymentRequest.commune ? { value: dataPaymentRequest.commune, label: dataPaymentRequest.commune } : null}
                        />
                    </span>
                    <span className='input-select'>
                        <label htmlFor='projects' className='hidden-label'>Proyecto</label>
                        <Select
                            name='holder'
                            id='holder'
                            options={dataPaymentRequest.commune ? dataProjects.filter((project) => project.commune === dataPaymentRequest.commune).map((holder) => ({
                                value: holder.nameProject,
                                label: holder.nameProject,
                                id: holder.id
                            }))
                                .sort((a, b) => a.label.localeCompare(b.label)) : []}
                            placeholder='Selecciona Proyecto'
                            className='custom-select'
                            classNamePrefix='custom-select'
                            components={{ DropdownIndicator }}
                            onChange={handleSelect}
                            value={dataPaymentRequest.holder?.value ? { 
                                value: dataPaymentRequest.holder.value, 
                                label: dataPaymentRequest.holder.value,
                                id: dataPaymentRequest.holder.id
                            } : null}
                        />
                    </span>
                    <span className='input-select'>
                        <label htmlFor='establishment' className='hidden-label'>Establecimiento</label>
                        <Select
                            name='establishment'
                            id='establishment'
                            options={dataPaymentRequest.commune ? establishmentList.filter((establishment) => establishment.projectId === dataPaymentRequest.holder?.id).map((establishment) => ({
                                value: establishment.nameEstablishment,
                                label: establishment.nameEstablishment,
                                id: establishment.id
                            }))
                                .sort((a, b) => a.label.localeCompare(b.label)) : []}
                            placeholder='Selecciona Establecimiento'
                            className='custom-select'
                            classNamePrefix='custom-select'
                            components={{ DropdownIndicator }}
                            onChange={handleSelect}
                            value={dataPaymentRequest.establishment?.value ? {
                                value: dataPaymentRequest.establishment.value,
                                label: dataPaymentRequest.establishment.value,
                                id: dataPaymentRequest.establishment.id
                            } : null}
                        />
                    </span>
                </article>
            )}
            {dataPaymentRequest.establishment.value && (
                <>
                    <article className='box-request-pending flex'>
                        <button
                            className={`box flex ${!canViewPendingRequests() ? 'disabled' : ''}`}
                            onClick={handleClick}
                            disabled={!canViewPendingRequests()}
                        >
                            <p>Este establecimiento tiene</p>
                            <span className='flex'>
                                <p className='number'>{pendingRequests.length}</p>
                            </span>
                            <p>Solicitudes aprobadas pendientes</p>
                        </button>
                        {observedRequests.length > 0 && (
                            <button
                                className={`box flex ${!canViewPendingRequests() ? 'disabled' : ''}`}
                                onClick={handleClickObserved}
                                disabled={!canViewPendingRequests()}
                            >
                                <p>Este departamento tiene</p>
                                <span className='flex'>
                                    <p className='number'>{observedRequests.length}</p>
                                </span>
                                <p>Solicitudes observadas</p>
                            </button>
                        )}
                        {rejectedRequests.length > 0 && (
                            <button
                                className={`box flex rejected ${!canViewPendingRequests() ? 'disabled' : ''}`}
                                onClick={handleClickRejected}
                                disabled={!canViewPendingRequests()}
                            >
                                <p>Este establecimiento tiene</p>
                                <span className='flex'>
                                    <p className='number'>{rejectedRequests.length}</p>
                                </span>
                                <p>Solicitudes de pago rechazadas</p>
                            </button>
                        )}
                    </article>
                    <article className='users-department flex'>
                        <p>Funcionarios {dataPaymentRequest.establishment?.value}</p>
                        <table>
                            <thead>
                                <tr>
                                    <th>Nombre Funcionario</th>
                                    <th>Contacto</th>
                                    <th>Correo</th>
                                    <th>Estado</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredUsers.map((user) => (
                                    <tr key={user.id}>
                                        <td data-label='Nombre Funcionario'>{formatDisplayName(user.displayName)}</td>
                                        <td data-label='Contacto'>{user.phoneNumber ? user.phoneNumber : 'S/N'}</td>
                                        <td data-label='Correo'>{formatDisplayName(user.email)}</td>
                                        <td data-label='Estado'>{user.state}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </article>
                </>
            )}
            {(viewPayment || viewObservedPayment || viewRejectedPayment) && (
                <ViewPendingPaymentRequest
                    view={viewPayment}
                    viewObserved={viewObservedPayment}
                    viewRejected={viewRejectedPayment}
                    setView={viewPayment ? setViewPayment : (viewObservedPayment ? setViewObservedPayment : setViewRejectedPayment)}
                    pendingRequests={viewPayment ? pendingRequests : (viewObservedPayment ? observedRequests : rejectedRequests)}
                    userData={userData}
                    establishmentList={establishmentList}
                    pmeList={pmeList}
                    projectId={userData?.permissions === 'admin' ? dataPaymentRequest.holder?.id : userData?.tenantId}
                    data={dataPaymentRequest}
                    selectedRequest={selectedRequestPayment}
                    setSelectedRequest={setSelectedRequestPayment}
                />
            )}
        </section>
    )
};

const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <img src={downArrow} alt="CustomArrow" />
        </components.DropdownIndicator>
    );
};

export default PaymentRequest;